import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Store} from "@/enums/Store";
import {UserInterface} from "@/types/User";

@Module({
  namespaced: true
})
export default class Customer extends VuexModule {
  customer?: UserInterface = undefined;

  @Mutation
  SET_CUSTOMER(user?: UserInterface) {
    this.customer = user;
  }

  @Action
  setCustomer(id?: string) {
    const {commit, rootGetters} = this.context;
    const invoiceRecipient = rootGetters[`${Store.MEMBER}/memberById`](id);
    commit('SET_CUSTOMER', invoiceRecipient)
  }

  @Action
  unsetCustomer() {
    const {commit} = this.context;
    commit('SET_CUSTOMER', undefined)
  }
}
